import React, { useState } from 'react'
import InfoIcon from '@mui/icons-material/InfoOutlined'
import { Box, Button, FormControl, FormControlLabel, Modal, Radio, RadioGroup, Typography } from '@mui/material'
import { ActivateOption, InactiveOption, MthColor, WithdrawalOption } from '@mth/enums'

type StatusChangeProps = {
  title: string
  description: string
  options: { value: number; label: string }[]
  subDescription?: string
  onClose: () => void
  onStatusChange: (value: WithdrawalOption | InactiveOption | ActivateOption) => void
  confirmStr?: string
  cancelStr?: string
}

export const StatusChangeModal: React.FC<StatusChangeProps> = ({
  title,
  description,
  options,
  subDescription,
  onClose,
  onStatusChange,
  confirmStr = 'Change Status',
  cancelStr = 'Cancel',
}) => {
  const [statusChangeOption, setStatusChangeOption] = useState<number>(0)
  // @ts-ignore
  const handleChange = (e) => {
    setStatusChangeOption(Number(e.target.value))
  }

  const handleWithdraw = () => {
    onStatusChange(statusChangeOption)
  }
  return (
    <Modal
      open={true}
      aria-labelledby='child-modal-title'
      disableAutoFocus={true}
      aria-describedby='child-modal-description'
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '550px',
          height: 'auto',
          bgcolor: MthColor.SYSTEM_09,
          borderRadius: 2,
          display: 'flex',
          justifyContent: 'center',
          p: 4,
        }}
      >
        <Box sx={{ textAlign: 'center' }}>
          <Typography variant='h5' fontWeight='bold'>
            {title}
          </Typography>
          <InfoIcon sx={{ fontSize: 50, margin: '20px 0px' }} />
          <Typography>{description}</Typography>
          {subDescription && <Typography>{subDescription}</Typography>}
          <Box sx={{ marginTop: '30px' }}>
            <FormControl>
              <RadioGroup
                aria-labelledby='demo-controlled-radio-buttons-group'
                name='controlled-radio-buttons-group'
                value={statusChangeOption}
                onChange={handleChange}
              >
                {options.map((option, index) => (
                  <FormControlLabel key={index} value={option.value} control={<Radio />} label={option.label} />
                ))}
              </RadioGroup>
            </FormControl>
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', marginTop: '30px', gap: '20px' }}>
            <Button
              sx={{ width: '160px', height: '36px', background: MthColor.SYSTEM_08, borderRadius: '50px' }}
              onClick={onClose}
            >
              {cancelStr}
            </Button>
            <Button
              sx={{
                width: '160px',
                height: '36px',
                background: '#43484F',
                borderRadius: '50px',
                color: 'white',
              }}
              onClick={handleWithdraw}
              disabled={!Boolean(statusChangeOption)}
            >
              {confirmStr}
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  )
}
